import { cn } from '@/lib/utils';

const SIZES = {
  xs: 'size-3 border',
  sm: 'size-4 border-2',
  md: 'size-5 border-2',
  lg: 'size-8 border-2',
} as const;

export interface SpinnerProps {
  size?: keyof typeof SIZES;
  className?: string;
  /** Подпись рядом с индикатором; всегда попадает в aria-label. */
  label?: string;
}

export function Spinner({ size = 'md', className, label }: SpinnerProps): React.JSX.Element {
  return (
    <span className={cn('inline-flex items-center gap-2 text-fg-muted', className)} role="status">
      <span
        className={cn(
          'animate-spin rounded-full border-current border-t-transparent opacity-70',
          SIZES[size],
        )}
        aria-hidden="true"
      />
      {label ? <span className="text-sm">{label}</span> : null}
      <span className="sr-only">{label ?? 'Загрузка'}</span>
    </span>
  );
}
